import { render, staticRenderFns } from "./SearchResultTabsAllSectionHeader.vue?vue&type=template&id=2f1186ce&scoped=true&"
import script from "./SearchResultTabsAllSectionHeader.vue?vue&type=script&lang=js&"
export * from "./SearchResultTabsAllSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultTabsAllSectionHeader.vue?vue&type=style&index=0&id=2f1186ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1186ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
